import { NgClass, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { ToastModule } from 'primeng/toast';
import { NotificationService } from '../../../../services/notification.service';
import { MessageModule } from 'primeng/message';
@Component({
    selector: 'app-manage-divisions',
    imports: [NextPage, TableModule, NgIf, MessageModule, NgClass, ButtonModule, FormsModule, ToastModule],
    templateUrl: './manage-divisions.component.html',
    styleUrl: './manage-divisions.component.scss'
})
export class ManageDivisionsComponent {
  divisionData: any = [];
  exportData: any = [];
  newDivisionName = ''
  newMaximoCode = '';
  SaveSuccess = false;
  errorData = false;
  isLoading: boolean = false;
  constructor(private adminService: AdminService, private commonService: CommonService, private notificationService: NotificationService) {
    this.isLoading = true;
    this.setDivisionData();
  }

  setDivisionData() {
    this.isLoading = true;
    this.adminService.getAllUserInteractions('manageDivisions').subscribe((response: any) => {
      this.divisionData = response;
      this.setExportData(response);
      this.processData();
    });
  };

  setExportData(data: any) {
    this.exportData = data.map((item: any) => ({
      RecID: item.RecID,
      FacilityID: item.FacilityID,
      DivisionName: item.DivisionName,
      DivisionMaximo: item.DivisionMaximo,
      DivisionRetired: item.DivisionRetired
    }));
  }

  processData() {
    this.divisionData.forEach((division: any) => {
      if (division.DivisionRetired == 'True') {
        division.status = 'Inactive';
        division.buttonName = 'Unretire'
      } else {
        division.status = 'Active';
        division.buttonName = 'Retire'

      }
    });
    this.isLoading = false;

  }

  retire(row: any) {
    if (confirm(`Are you sure you want to update a record?`)) {

      let payload = {
        "region": "Division",
        "recID": row.RecID,
        "retired": row.DivisionRetired == 'True' ? false : true
      }

      this.adminService.RETIREUSERINTERACTION(payload).subscribe({
        next: (message: any) => {
          this.notificationService.showSuccess(message.message);
          this.setDivisionData();
        }
      })
    }

  }

  addDivision() {
    this.errorData = false;
    this.SaveSuccess = false;
    if (this.newDivisionName == '' || this.newMaximoCode == '') {
      this.errorData = true;
      this.notificationService.showError("Please fill all the fields" );
      return;
    }
    let payload = {
      region: "Division",
      data: {
        DivisionName: this.newDivisionName,
        DivisionMaximo: this.newMaximoCode,
        FacilityID: this.commonService.getCurrentFacilityId(),
      }
    }

    this.adminService.submitUserInteraction(payload).subscribe({
      next: (message: string) => {
        this.SaveSuccess = true;
        this.notificationService.showSuccess(message);
        this.newDivisionName = '';
        this.newMaximoCode = '';
        this.setDivisionData();
      }
    })
  }

  exportToExcel() {
    this.commonService.exportToExcel(this.exportData, 'TLRAdmin-Divisions.xlsx', 'TLRAdmin-Divisions');
    this.notificationService.showSuccess("file downloaded successfully");
  }
  changeNav(){
    this.SaveSuccess = false;
    this.errorData = false;
  }
}
